// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GiftTwoToneSvg from "@fishx/icons-svg/es/asn/GiftTwoTone";
import FishxIcon from '../components/FishxIcon';

var GiftTwoTone = function GiftTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GiftTwoToneSvg
  }));
};

GiftTwoTone.displayName = 'GiftTwoTone';
export default React.forwardRef(GiftTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GiftTwoTone.js
// module id = 2865
// module chunks = 0